// extracted by mini-css-extract-plugin
export var IconsContainer = "BlogTemplate-module--IconsContainer--d84af";
export var allContent = "BlogTemplate-module--allContent--75ff2";
export var blogBack = "BlogTemplate-module--blogBack--563da";
export var blogBackArrow = "BlogTemplate-module--blogBackArrow--f12b5";
export var blogBackText = "BlogTemplate-module--blogBackText--acdd2";
export var blogContainer = "BlogTemplate-module--blogContainer--32fc8";
export var blogContent = "BlogTemplate-module--blogContent--1cdfc";
export var blogHeadings = "BlogTemplate-module--blogHeadings--3819c";
export var blogList = "BlogTemplate-module--blogList--b6f29";
export var blogReferences = "BlogTemplate-module--blogReferences--c068e";
export var blogTitle = "BlogTemplate-module--blogTitle--4936b";
export var bottomIconsContainer = "BlogTemplate-module--bottomIconsContainer--6f6c3";
export var bottomRecentArticlesContainer = "BlogTemplate-module--bottomRecentArticlesContainer--ec76e";
export var bottomShareIcon = "BlogTemplate-module--bottomShareIcon--e7692";
export var contentIconsContainer = "BlogTemplate-module--contentIconsContainer--1a1d1";
export var date = "BlogTemplate-module--date--95272";
export var flagTopIcon = "BlogTemplate-module--flagTopIcon--5ac81";
export var formBody = "BlogTemplate-module--formBody--bec27";
export var formContainer = "BlogTemplate-module--formContainer--bf3a6";
export var formField = "BlogTemplate-module--formField--70090";
export var gradientOrb = "BlogTemplate-module--gradientOrb--832fb";
export var hiddenReference = "BlogTemplate-module--hiddenReference--49175";
export var mainBlogContent = "BlogTemplate-module--mainBlogContent--91d34";
export var mainBlogImage = "BlogTemplate-module--mainBlogImage--0eb20";
export var medicalReviewerContainer = "BlogTemplate-module--medicalReviewerContainer--8cc47";
export var recentArticlesContainer = "BlogTemplate-module--recentArticlesContainer--46e91";
export var recentHeading = "BlogTemplate-module--recentHeading--15018";
export var referenceContainer = "BlogTemplate-module--referenceContainer--81805";
export var referenceIcon = "BlogTemplate-module--referenceIcon--3dba3";
export var referenceList = "BlogTemplate-module--referenceList--8c9a4";
export var shareIcons = "BlogTemplate-module--shareIcons--bd90c";
export var sideArticlesContainer = "BlogTemplate-module--sideArticlesContainer--98755";
export var smallBlogContainer = "BlogTemplate-module--smallBlogContainer--d1439";
export var topIcons = "BlogTemplate-module--topIcons--f7695";